module.exports = __webpack_public_path__ + "static/media/linked-in.280f4b46.svg";